/**
 * Landing page for /sso/logout-complete.
 *
 * Reached two ways: after we asked the provider to end its session, and after
 * the provider told us the user signed out somewhere else. The second case can
 * arrive in a tab that still holds a session in storage, so this page clears it
 * rather than assuming the logout started here.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Auth.scss';

function SsoLogoutComplete() {
  const navigate = useNavigate();

  useEffect(() => {
    // The tokens are already dead server-side; this stops the UI from
    // rendering as though someone is still signed in.
    sessionStorage.clear();
    // Land the user straight on our own sign-in screen rather than a static
    // confirmation card. Also covers provider-initiated logout reaching here.
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="sso_status_wrapper">
      <div className="sso_status_card">
        <h2 className="sso_status_title">Signing you out…</h2>
      </div>
    </div>
  );
}

export default SsoLogoutComplete;
